import { render, staticRenderFns } from "./Double11Activity.vue?vue&type=template&id=e862d8e2&scoped=true"
import script from "./Double11Activity.vue?vue&type=script&lang=js"
export * from "./Double11Activity.vue?vue&type=script&lang=js"
import style0 from "./Double11Activity.vue?vue&type=style&index=0&id=e862d8e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e862d8e2",
  null
  
)

export default component.exports